// InventoryAdminInventory - Inventory Status Component
import React from 'react';
import '../../../../assests/css/admin/Analytics/InventoryStatus/InventoryStatus.css';

const InventoryStatus = () => {
  const inventoryItems = [
    {
      name: 'Electronics',
      status: 'healthy',
      statusText: 'Healthy: 95%',
      percentage: 95
    },
    {
      name: 'Accessories',
      status: 'critical',
      statusText: 'Critical: 12%',
      percentage: 12
    },
    {
      name: 'Home & Office',
      status: 'restock',
      statusText: 'Restock soon: 62%',
      percentage: 62
    }
  ];

  return (
    <div className="InventoryAdminInventory-inventory-status">
      <div className="InventoryAdminInventory-inventory-header">
        <div>
          <div className="InventoryAdminInventory-inventory-title">
            Inventory Status
          </div>
          <div className="InventoryAdminInventory-inventory-subtitle">
            View stock levels and critical items
          </div>
        </div>
        <div className="InventoryAdminInventory-critical-badge">
          <span>⚠</span>
          <span>4 Critical Items</span>
        </div>
      </div>

      <div className="InventoryAdminInventory-inventory-summary">
        <div className="InventoryAdminInventory-summary-card">
          <div className="InventoryAdminInventory-summary-label">Total Stock</div>
          <div className="InventoryAdminInventory-summary-value">12,482</div>
          <div className="InventoryAdminInventory-summary-subtitle">Units Active</div>
        </div>
        <div className="InventoryAdminInventory-summary-card">
          <div className="InventoryAdminInventory-summary-label">Total Value</div>
          <div className="InventoryAdminInventory-summary-value">$2.4M</div>
          <div className="InventoryAdminInventory-summary-subtitle">+5.2% Last Month</div>
        </div>
      </div>

      <div className="InventoryAdminInventory-inventory-list">
        {inventoryItems.map((item, index) => (
          <div key={index} className="InventoryAdminInventory-inventory-item">
            <div className="InventoryAdminInventory-item-info">
              <div className="InventoryAdminInventory-item-name">{item.name}</div>
              <div className={`InventoryAdminInventory-item-status ${item.status}`}>
                <div className={`InventoryAdminInventory-status-dot ${item.status}`}></div>
                {item.statusText}
              </div>
            </div>
            <div className="InventoryAdminInventory-progress-container">
              <div className="InventoryAdminInventory-progress-bar">
                <div 
                  className={`InventoryAdminInventory-progress-fill ${item.status}`}
                  style={{ width: `${item.percentage}%` }}
                ></div>
              </div>
              <div className="InventoryAdminInventory-progress-label">
                {item.percentage}% in stock
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InventoryStatus;